import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  TextField as MuiTextField,
  Tooltip,
  tooltipClasses,
  Typography,
} from "@mui/material";

import { styled } from "@mui/material/styles";

import formatNumber from "../../../utils/formatNumber";

const formatDataRevenue = (value) => value && formatNumber(value, { style: "percent", maximumFractionDigits: 2 });

const MarginTooltip = styled(({ className, ...props }) => (
  <Tooltip
    title="Margin on Audience cost used to calculate Data Revenue"
    arrow
    classes={{ popper: className }}
    {...props}
  />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "none",
  },
});

const TextField = styled(({ ...props }) => (
  <MuiTextField {...props} sx={{ fontSize: 14 }} />
))({
  "& .MuiInputBase-root": {
    fontSize: 14,
  },
});

const PricingVariableCard = ({
  state,
  showActionButtons,
  disableConfirm,
  dataRevenueShare,
  onCancel,
  onConfirm,
}) => {
  return (
    <Card sx={{ mb: 2 }}>
      <CardHeader title="Pricing Variable" />
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <MarginTooltip>
            <Typography
              variant="body2"
              color="text.secondary"
              component={"div"}
            >
              Data Revenue Share (%)
            </Typography>
          </MarginTooltip>
          <TextField
            variant="outlined"
            size="small"
            InputProps={{
              readOnly: true,
              sx: {
                ...(state === "changed" && { color: "info.main" }),
              },
            }}
            {...(state === "changed" && { color: "info", focused: true })}
            sx={{ ml: 2, maxWidth: 90 }}
            error={state === "error"}
            value={formatDataRevenue(state === "error" ? 0 : dataRevenueShare) ?? ""}
            inputProps={{
              sx: { textAlign: "center" }
            }}
          />
        </Box>
        {showActionButtons && (
          <Box sx={{ display: "flex", direction: "row", pt: 2 }}>
            <Button
              disabled={disableConfirm}
              color="primary2"
              variant="contained"
              onClick={onConfirm}
            >
              Confirm
            </Button>
            <Button
              variant="contained"
              onClick={onCancel}
              color="primary2"
              sx={{ ml: 2 }}
            >
              Cancel
            </Button>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default PricingVariableCard;
